import React from 'react'
import Moment from 'react-moment'
import { numberFormat } from 'core/utilities'
import * as v from 'variables/styles'
import { purchaseOrderDetailPath, goodsServiceReceiptDetailPath, contractDetailPath } from 'routes'
import {StatusTag} from 'components'

const linkStyle = {
  color: v.ezMainColor,
  fontWeight: 'bold',
  textDecoration: 'underline',
  cursor: 'pointer',
}

const headerStyle = {
  color: v.ezMainColor,
  fontWeight: 'bold',
}

//convert payment status for tag color
const convertPaymentStatus = {
  1:0,
  2:2,
  3:1,
  10:4,
  12:5
}

export const blInvoiceColumns = [
  {
    Header: 'Status',
    accessor: 'statusName',
    width: 130,
    className: 'left',
    Cell: row => <StatusTag status={convertPaymentStatus[row.original.status]} statusName={row.value} />,
  },{
    Header: ' Invoice No.',
    accessor: 'invoiceNumber',
    className: 'left',
  }, {
    Header: <span>Delivery<br/>Type</span>,
    accessor: 'deliveryType',
    width: 100,
    className: 'center',
  }, {
    Header: 'Net Amount',
    accessor: 'invoiceAmount',
    className: 'right',
    Cell: row => numberFormat(row.value, true),
  }, {
    Header: 'Currency',
    accessor: 'currencyCode',
    width: 70,
    className: 'center itemCurrency',
  }, 
  {
    Header: <span>Estimate<br/>Due Date</span>,
    accessor: 'estimateDueDate',
    className: 'center ',
    Cell: row => (row.value ? <Moment format='DD MMM YYYY' locale={'en-en'}>{row.value}</Moment> : null)
  },
  {
    Header: 'Payment Type',
    accessor: 'paymentType',
    className: 'center ',
  },
  {
    Header: <span>Payment No./<br/>Cheque No.</span>,
    accessor: 'paymentNo',
    className: 'center ',
    Cell: row => (row.value ? <span>{row.value.split('/')[0]}/<br/>{row.value.split('/')[1]}</span>: null)
  },
  {
    Header: <span>Payment Date/<br/>Clearing Date</span>,
    accessor: 'dueDate',
    className: 'center ',
    Cell: row => (row.value ? <Moment format='DD MMM YYYY' locale={'en-en'}>{row.value}</Moment> : null)
  },
  {
    Header: 'LIV No.',
    accessor: 'invoiceSapDocNo',
    resizable: false,
    className: 'center ',
  }
]

export const blItemColumns = [
  {
    accessor: 'grNumber',
    className: 'center',
    Cell: row => <div style={linkStyle} onClick={() => window.open(goodsServiceReceiptDetailPath(row.original.grUrl), '_blank')} >GR No.  {row.value || '-'} -  {row.original.grSapNumber}</div>
  }, {
    accessor: 'poNumber',
    className: 'center',
    Cell: row => <div style={linkStyle} onClick={() => window.open(purchaseOrderDetailPath(row.original.poUrl), '_blank')} >PO No.  {row.value || '-'} - {row.original.poSapNumber}</div>
  }, {
    accessor: 'mainContract',
    className: 'center',
    Cell: row => <div>
      <div style={headerStyle}>Contract</div>
      {
        row.original.mainContractId ? row.original.mainContractId.split(',').map((x, i) => {
          let c = row.original.mainContractNo.split(',')
          return (
            <div style={linkStyle} onClick={() => window.open(contractDetailPath(x), '_blank')} >{c[i]}</div>
          )
        }) : ''
      }
    </div>
  }
]